import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM10.48 16.37L6.34 12.76L7.66 11.25L10.4 13.64L16.3 7.79L17.71 9.21L10.49 16.36L10.48 16.37Z" fill={ fill || 'currentColor' } />
    </svg>
);
